<script setup>
import MacosSetup from "./setup.vue";
import {ref, toRefs, watch} from "vue";

const _default_assets_ = [
  { name: '下载 Apple 芯片版(Mac)' },
  { name: '下载 Intel 芯片版(Mac)' }
];

const props = defineProps({
  assets: {
    type: Array,
    default: () => []
  }
})
const refs = toRefs(props);
const assets = ref(_default_assets_.slice());

watch(refs.assets, (value) => {
  if ( !value || value.length === 0 ) return;

  assets.value = value;
});
</script>

<template>
  <el-row>
    <el-col :span="8">
      <div class="platform-options">
        <div class="btn-group btn-download-group">
          <a class="option-btn download-btn" v-for="item in assets"
             :class="!item.href ? 'disabled': ''"
             :href="item.href" target="_blank">
            {{item.name}}
          </a>
        </div>
        <div>
          <p class="hint">针对Intel芯片和Apple芯片的Mac电脑进行了优化，使用正确的版本有助于降低资源消耗，提升软件性能。</p>
          <p class="hint">如果您的 Mac 是 2020 年以后的型号，可以选择 Apple芯片版本下载</p>
          <p class="hint">* 如果你无法确认芯片版本，可直接下载Intel版</p>
        </div>
<!--        <a class="help-link" href="javascript:void(0)">
          如何确认我的 Mac 芯片类型？
        </a>-->
      </div>
    </el-col>
    <el-col :span="16">
      <macos-setup/>
    </el-col>
  </el-row>
</template>
